module.exports = __webpack_public_path__ + "img/pt.a102e563.svg";